import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const BusbarSizingCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-busbar-sizing-calculator" />;

export default BusbarSizingCalculatorGuidePage;
